import { getDevicePref, setDevicePref } from "@eventr/common";
import { deviceDetect } from "react-device-detect";
import { create } from "zustand";
import { getDevicePrefName } from "../../utils";

const PREF = "tabRailLeft";

/** The setting on a device where nobody has changed it: the rail on the right. */
export const TAB_RAIL_LEFT_DEFAULT = false;

interface TabRailSideState {
  /** Whether this device draws the tab rail down the left-hand edge instead of the right. */
  tabRailLeft: boolean;
  setTabRailLeft: (tabRailLeft: boolean) => void;
}

const device = getDevicePrefName(deviceDetect);

// A device preference, not reset on logout.
export const useTabRailSideStore = create<TabRailSideState>()((set) => ({
  tabRailLeft: (getDevicePref(PREF, device, undefined) as boolean | undefined) ?? TAB_RAIL_LEFT_DEFAULT,
  setTabRailLeft: (tabRailLeft) => {
    // `setDevicePref` types its value as a string but stores it as JSON.
    setDevicePref(PREF, tabRailLeft as unknown as string, device);
    set({ tabRailLeft });
  },
}));

export const useTabRailLeft = () => useTabRailSideStore((s) => s.tabRailLeft);
